/**
 * WelcomeStrip — a small, professional welcome line that sits at the top
 * of every landing page (admin Home, Property Manager, Staff, Tenant).
 *
 * Same exact format on every role so the user feels welcomed by name on
 * their appropriate work page. Names use the original italic signature style.
 *
 * Props:
 *   name      – full name to render (required)
 *   subtitle  – optional context line under the name (role / property)
 *   accent    – override the gold left-rule color (defaults to #C9A962)
 */
export default function WelcomeStrip({ name, subtitle, accent = '#C9A962', nameColor = '#0a0a0a', testid = 'welcome-strip', welcomeLabel = 'Welcome' }) {
  if (!name) return null;
  return (
    <div className="mb-5 flex items-start gap-3" data-testid={testid}>
      <div
        aria-hidden
        className="mt-2 h-7 w-[3px] rounded-full flex-shrink-0"
        style={{ background: `linear-gradient(180deg, ${accent} 0%, transparent 100%)` }}
      />
      <div className="min-w-0">
        <p
          className="text-[10px] uppercase tracking-[0.32em] font-semibold"
          style={{ color: accent, fontFamily: 'Barlow Condensed, sans-serif' }}
        >
          {welcomeLabel}
        </p>
        <h2
          className="necs-dashboard-name text-lg sm:text-xl"
          style={{ color: nameColor }}
          data-testid={`${testid}-name`}
        >
          {name}
        </h2>
        {subtitle && (
          <p className="text-[11px] text-zinc-500 mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
